import { render } from "./SubmenuTopMore.vue?vue&type=template&id=363dccb0&scoped=true"
import script from "./SubmenuTopMore.vue?vue&type=script&lang=js"
export * from "./SubmenuTopMore.vue?vue&type=script&lang=js"

import "./SubmenuTopMore.vue?vue&type=style&index=0&id=363dccb0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363dccb0"]])

export default __exports__